import React from 'react';
import { MessageCircleIcon } from 'lucide-react';
import { Reveal } from '../ui/Reveal';
import { LinkButton } from '../ui/Button';
import { contact } from '../../data/site';
export function FinalCTA() {
  return <section className="bg-teal py-20 text-white lg:py-28" data-id="element-131" data-mp="3msqow7287wlq">
      <Reveal className="mx-auto max-w-3xl px-5 text-center lg:px-10" data-id="element-132" data-mp="3rsv4zvz82pbf">
        <p className="eyebrow text-white/60" data-id="element-133" data-mp="3rr0mspfc5bb1">{contact.tagline}</p>
        <h2 className="mt-6 font-display text-[2.1rem] font-semibold leading-[1.12] tracking-[-0.02em] sm:text-[2.8rem] lg:text-[3.2rem]" data-id="element-134" data-mp="3ds0tv5ksia92">
          Tu futuro merece protección.
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-[15px] font-light leading-relaxed text-white/75" data-id="element-135" data-mp="33vpjil4rfuh9">
          Da el primer paso y conoce las opciones que pueden estar disponibles para ti.
        </p>
        <div className="mt-10 flex flex-col justify-center gap-3 sm:flex-row" data-id="element-136" data-mp="1239ovrh7hq6v">
          <LinkButton href="#agenda" variant="light" size="lg" className="w-full sm:w-auto" data-id="element-137" data-mp="172dvqbgnrbu1">
            AGENDA UNA CITA
          </LinkButton>
          <LinkButton href={contact.whatsapp} target="_blank" rel="noopener noreferrer" variant="outlineLight" size="lg" className="w-full sm:w-auto" data-id="element-138" data-mp="q72daym2br1n">
            <MessageCircleIcon size={16} strokeWidth={1.6} data-id="element-139" data-mp="z2rxj4bryfdg" />
            ESCRÍBEME POR WHATSAPP
          </LinkButton>
        </div>
      </Reveal>
    </section>;
}